module.exports = __webpack_public_path__ + "static/img/slide_12.ab069cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/slider/slide_12.png
// module id = vryt
// module chunks = 0